<template>
    <div class="EvaluationSecond" id="EvaluationSecond" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.7)" element-loading-text="文件正在下载，请稍等" element-loading-spinner="el-icon-loading">
      <div class="evaluateMain">
        <div class="table_panel">
            <span style="font-size:14px;font-weight:600">公路隧道总体技术状况评定类别</span>
        </div>
        <div class="table">
            <el-table
                :header-cell-style="{background:'#335ABB',color:'#FFF'}"
                :data="tableData"
                stripe
                style="width: 100%;font-size:14px;">
                <el-table-column
                    prop="classify"
                    label="分类"
                    align="center"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="eva"
                    label="总体评定"
                    align="center"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="description"
                    align="center"
                    label="评定类别描述">
                </el-table-column>
            </el-table>

            <div class="table_panel">
                <span style="font-size:14px;font-weight:600">隧道衬砌破损技术状况评定标准</span>
            </div>
            <el-table
                :header-cell-style="{background:'#335ABB',color:'#FFF'}"
                :data="tableData_second"
                stripe
                style="width: 100%;font-size:14px;">
                <el-table-column
                    prop="classify"
                    label="状况值"
                    align="center"
                    width="180">
                </el-table-column>
                <!-- 多级表头 -->
                <el-table-column label="技术状态描述" header-align="center">
                    <el-table-column
                        prop="eva"
                        label="外荷载作用所致"
                        align="center"
                        width="400">
                    </el-table-column>
                    <el-table-column
                        prop="description"
                        align="center"
                        label="材料劣化所致">
                    </el-table-column>
                </el-table-column>
            </el-table>
            <div class="table_panel">
                <span style="margin-right:25%;color:#E68F02;" @click="downloadLeft()">公路隧道养护技术规范（JTG H12-2015）</span>
                <span style="color:#E68F02;" @click="downloadRight()">公路隧道施工技术规范（JTGT3660-2020）</span>
            </div>
        </div>
      </div>
    </div>
</template>

<script>

    export default {
        name: 'EvaluationSecond',
        data() {
            return {
                tableData: [{
                    classify: '1类',
                    eva: '完好状态',
                    description: '无异常情况，或异常情况轻微，对交通安正常全无影响'
                }, {
                    classify: '2类',
                    eva: '轻微破损',
                    description: '存在轻微破损，现阶段趋于稳定，对交通安全不会有影响'
                }, {
                    classify: '3类',
                    eva: '中等破损',
                    description: '存在破坏，发展缓慢，可能会影响行人、行车安全'
                }, {
                    classify: '4类',
                    eva: '严重破损',
                    description: '存在较严重破坏，发展较快，已影响行人、行车安全'
                },{
                    classify: '5类',
                    eva: '危险状态',
                    description: '存在严重破坏，发展迅速，已危及行人、行车安全'
                }],

                tableData_second: [{
                    classify: '0',
                    eva: '结构无裂损、变形和背后空洞',
                    description: '材料无劣化'
                }, {
                    classify: '1',
                    eva: '出现变形、位移、沉降和裂缝，但无发展或已停止发展',
                    description: '存在材料劣化，钢筋表面局部腐蚀，衬砌出现变形、位移、沉降和裂缝，但无发展或已停止发展'
                }, {
                    classify: '2',
                    eva: '出现变形、位移、沉降和裂缝，发展缓慢，边墙衬砌背后存在空原，有扩大的可能',
                    description: '材料劣化明显，钢筋表面全部生锈、腐蚀，析面强度有所下降，结构物功能可能受到损害'
                }, {
                    classify: '3',
                    eva: '出现变形、位移、沉降，裂缝密集，出现剪切性裂缝，发展速度较快;边墙处衬砌压裂，导致起层、剥落，边墙混凝土有可能掉下;拱部背面存在大的空洞，上部落石可能掉落至拱背;衬砌结构侵人内轮廓界限',
                    description: '材料劣化严重，钢筋断面因腐蚀而明显减小，断面强度有相当程度的下降，结构物功能受到损害;边墙混凝土起层、剥落，混凝土块可能掉落或已有掉落'
                },{
                    classify: '4',
                    eva: '衬砌结构发生明显的永久变形，裂縫密集，出现剪切性裂缝，裂缝深度贯穿衬砌混凝土，并且发展快速;由于拱顶裂缝密集，衬砌开裂，导致起层、剥落，混凝土块可能掉下;衬砌拱部背面存在大的空洞，且村砌有效厚度很薄，空腔上部可能掉落至拱背;衬砌结构侵人建筑限界。',
                    description: '材料劣化非常严重，断面强度明显下降,结构物功能损害明显;由于拱部材料劣化,导致混凝土起层、剥落，混凝土块可能掉落或已有掉落'
                }],
                loading: false,
            };
        },
        mounted:function(){

        },
        methods:{
            downloadLeft(){
                this.loading = true;
                const req = '公路隧道养护技术规范-JTG H12- 2015'
                this.$axios.get('/api/monitor/safe/downLoadPdf?fileName='+req, {responseType: 'blob'}).then(res => {
                    if(!res){
                        this.loading = false;
                        return
                    }
                    if(res.data.status==404){
                        this.loading = false;
                        return
                    }
                    const _res = res.data;
                    if(_res.type == 'application/octet-stream'){
                        this.loading = false;
                    }
                    let blob = new Blob([_res], {type: 'application/pdf;charset=UTF-8'});
                    let downloadElement = document.createElement("a");
                    let href = window.URL.createObjectURL(blob);
                    downloadElement.href = href;
                    downloadElement.download = `公路隧道养护技术规范(JTG H12- 2015).pdf`;
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                    window.URL.revokeObjectURL(href);
                    setTimeout(()=>{this.loading = false;},1500)

                })
            },
            downloadRight(){
                this.loading = true;
                const req = '公路隧道施工技术规范-JTGT3660-2020'
                this.$axios.get('/api/monitor/safe/downLoadPdf?fileName='+req, {responseType: 'blob'}).then(res => {
                    if(!res){
                        this.loading = false;
                        return
                    }
                    if(res.data.status==404){
                        this.loading = false;
                        return
                    }
                    const _res = res.data;
                    if(_res.type == 'application/octet-stream'){
                        this.loading = false;
                    }
                    let blob = new Blob([_res], {type: 'application/pdf;charset=UTF-8'});
                    let downloadElement = document.createElement("a");
                    let href = window.URL.createObjectURL(blob);
                    downloadElement.href = href;
                    downloadElement.download = `公路隧道施工技术规范(JTGT3660-2020).pdf`;
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                    window.URL.revokeObjectURL(href);
                    setTimeout(()=>{this.loading = false;},1500)

                })
            }
        }
    }
</script>

<style>

    #EvaluationSecond .el-table{
        color: #A7CCF6;
    }

    #EvaluationSecond .el-table__row {
        background-color: #0B3A68 !important;
    }

    #EvaluationSecond .el-table--striped .el-table__body tr.el-table__row--striped td{
        background-color: #021535;
    }

    #EvaluationSecond .el-table td{
        border: unset;
    }

    #EvaluationSecond .el-table th.is-leaf{
        border-bottom: none;
    }

</style>

<style scoped>
    @import url('../../assets/css/style.css');
</style>



// WEBPACK FOOTER //
// src/components/evaluation/EvaluationSecond.vue